import * as React from 'react';
import styled from 'styled-components';
import { rem, rgba } from 'polished';
import { TextP } from '../../Defaults/Text';
import { IconType, SvgIcon } from '../General/SvgIcon';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { getSymbolFromCurrency, prop } from '../../../utilities';

export interface Props {
  amount: number | null;
  currency?: string;
  amountFreeDelivery?: number | null;
  freeDeliveryInfo?: string;
  isProduct?: boolean;
}

function SanitasFreeDeliveryInfo({
  amount,
  currency = 'EUR',
  freeDeliveryInfo,
  isProduct = true,
}: Props) {
  if (amount === null) {
    return amount;
  }
  let percentage = 0;
  const freeDeliveryFrom = prop(freeDeliveryInfo, 'price', 0);

  if (freeDeliveryFrom > 0) {
    percentage = 100 - (amount / freeDeliveryFrom) * 100;
  }

  const curencySymbol = getSymbolFromCurrency(currency);
  return (
    <Wrapper isProduct={isProduct}>
      <FirstLineWrapper>
        <StyledSvgIcon
          icon={IconType.caddy}
          width={24}
          height={24}
          alt={'List icon'}
          viewBox="0 0 24 24"
          marginRight={16}
        />
        {amount > 0 ? (
          <Text amount={amount}>
            {__(`Nakúpte ešte za`)}{' '}
            <Amount>
              {amount} {curencySymbol}
            </Amount>{' '}
            {__(`a dopravu máte zadarmo`)}
          </Text>
        ) : (
          <Text>
            {__(`Dopravu máte`)} <TextHighlight> {__(`zdarma`)}!</TextHighlight>
          </Text>
        )}
      </FirstLineWrapper>
      <SecondLineWrapper>
        <Progress width={percentage} />
      </SecondLineWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)<{ padding: string; isProduct: boolean }>`
  padding: ${rem(24)};
  background-color: ${rgba('#2CC5B7', 0.08)};
  border-radius: ${rem(8)};

  ${({ theme }) => theme.mediab.m600`
  margin: 0 ${rem(16)} ${rem(8)} ${rem(16)};
  `}
  margin: ${({ isProduct }) =>
    isProduct ? ` 0 ${rem(24)};` : `${rem(24)} ${rem(24)} 0 ${rem(24)}`}}

`;

const FirstLineWrapper = styled.div`
  display: flex;
`;

const Amount = styled.span`
  font-size: ${rem(16)};
  line-height: ${rem(24)};
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 700;
  ${({ theme }) => theme.mediab.m600`
  font-size: ${rem(14)};
  line-height: ${rem(17)};
`}
`;

const Text = styled(TextP)<{ amount }>`
  font-size: ${rem(16)};
  line-height: ${rem(24)};
  font-family: ${({ theme }) => theme.font.primary};

  ${({ theme }) => theme.mediab.m600`
    font-size: ${rem(14)};
    line-height: ${({ amount }) => (amount ? rem(17) : rem(30))}}
    
   
  `}
  ${({ theme }) => theme.mediab.s450`
      margin-left: ${rem(8)};
  `}
`;

const TextHighlight = styled.span`
  font-weight: 700;
  font-size: ${rem(16)};
  line-height: ${rem(24)};
  font-family: ${({ theme }) => theme.font.primary};
  ${({ theme }) => theme.mediab.m600`
    font-size: ${rem(14)};
    line-height: ${rem(17)};
`}
`;
const SecondLineWrapper = styled.div`
  margin-top: ${rem(16)};
  height: ${rem(4)};
`;

const Progress = styled.div<{ width: number }>`
  width: 100%;
  height: ${rem(4)};
  position: relative;
  border-radius: ${rem(2)};
  background: ${rgba('#2CC5B7', 0.24)};
  border-radius: ${rem(4)};

  &:after {
    content: '';
    position: absolute;
    background: ${({ theme }) => theme.colors.primary};
    top: 0;
    bottom: 0;
    left: 0;
    width: ${({ width }) => `${width}%`};
  }

  ${({ theme }) => theme.mediab.m810`
   margin-bottom: ${rem(8)};
  `}
`;

const StyledSvgIcon = styled(SvgIcon)`
  ${({ theme }) => theme.mediab.m600`
    
  `}
  ${({ theme }) => theme.mediab.s450`
  width: ${rem(32)};
  height: ${rem(32)};
  margin-right: ${rem(8)};
  `}
`;

export { SanitasFreeDeliveryInfo };
